// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stat--StatWrapper--KWm_y {
  position: relative;
  overflow: visible;
}

.Stat--Stat--cQ2U_ {
  background-color: var(--bkgrnd-white);
  border-radius: 8px;
  border: 1px solid var(--stat--border);
}

.Stat--Stat--cQ2U_ tspan {
  font-family: "Basis", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-weight: 500 !important;
}

.Stat--statHeader--TPpS6 {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
  height: 1.5em;
  margin: 0.25em 0.625em;
  overflow: hidden;
}

.Stat--statMain--bVDPU {
  padding: 0 0.625em;
  overflow: hidden;
}

.statCollapse {
  transition: height 250ms;
}

.Stat--statFooter--mEztE {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--stat--border);
  padding: 0.25em 0.625em .375em;
  overflow: hidden;
}

.Stat--chartTitle--lZSYG {
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  margin-top: .25em;
  color: var(--stat--default);
  width: 100%;
  min-width: 0;
  display: flex;
}

.Stat--chartTitleText--uzqDQ {
  display: inline-block;
  min-width: 0;
  overflow-x: clip;
  text-overflow: ellipsis;
}

.Stat--chartSummary--QudLx {
  line-height: 1;
  display: flex;
  justify-content: space-between;
}

.Stat--summaryData--wSEtu {
  display: inline-block;
  white-space: nowrap;
  padding-right: .35em;
  padding-left: .35em;
}

.Stat--summaryData--wSEtu:last-child {
  padding-right: 0;
}

.Stat--summaryValue--njf4T {
  opacity: 1;
  display: inline-block;
  font-weight: 500;
}

.Stat--summarySuffix--KBz9E {
  color: var(--stat--default);
  font-weight: normal;
  position: relative;
  bottom: 1px;
  padding-left: 1px;
}

.Stat--units--XCEsR {
  color: var(--stat--default);
  font-weight: normal;
  align-self: center;
  line-height: 24px;
  padding-left: .5em;
}

.Stat--chartTitleData--TmZ6Q {
  display: none;
  padding-left: .25em;
  align-items: center;
  position: relative;
  top: -1px;
  color: var(--stat--default);
}

.Stat--chartTitleData--TmZ6Q span {
  margin-top: 1px;
}

.Stat--chartTitleSuffix--CgcRd {
  font-weight: normal;
  padding-left: 1px;
}

.Stat--Stat--cQ2U_.Stat--isOpen--IIudz .Stat--chartTitleData--TmZ6Q {
  display: inline-flex;
}

.Stat--chartCollapse--jo1M7 {
  margin-bottom: 0;
  margin-right: -0.3em;
  height: 24px;
  line-height: 1;
}

.Stat--chartCollapse--jo1M7 img {
  position: relative;
  cursor: pointer;
}

.Stat--chartWrapper--jkeYr {
  padding-bottom: .125em;
}

.Stat--inputWrapper--wlg0q {
  padding: 0.5em 0.625em .5em;
}

.Stat--inputWrapper--wlg0q label {
  font-weight: 500;
}

.Stat--inputWrapper--wlg0q input[type="number"] {
  width: 45px;
}

.Stat--outputWrapper--qgnDe {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: var(--stat--default);
}

.Stat--outputValue--on2Ws {
  font-weight: 500;
  color: var(--stat--default);
  margin-right: .25em;
  position: relative;
  top: 1px;
}

.Stat--outputSuffix--WEbZg {
  color: var(--stat--default);
}

.Stat--outputValueDisabled--ydkWF {
  color: var(--stat--default);
}

.Stat--outputLabel--CtKR1 {
  font-weight: 500;
  color: var(--stat--default);
}

.Stat--tooltipIcon--jgX3r {
  position: relative;
  top: -0.3em;
  margin-left: 0.1em;
}

.Stat--tooltipIcon--jgX3r > img {
  width: 0.9em;
}

.Stat--StatTooltipWrapper--i8dsZ {
  z-index: 1;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/stat/Stat.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,+EAA+E;EAC/E,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,UAAU;EACV,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".StatWrapper {\n  position: relative;\n  overflow: visible;\n}\n\n.Stat {\n  background-color: var(--bkgrnd-white);\n  border-radius: 8px;\n  border: 1px solid var(--stat--border);\n}\n\n.Stat tspan {\n  font-family: \"Basis\", \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n  font-weight: 500 !important;\n}\n\n.statHeader {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: 1.5em;\n  margin: 0.25em 0.625em;\n  overflow: hidden;\n}\n\n.statMain {\n  padding: 0 0.625em;\n  overflow: hidden;\n}\n\n:global(.statCollapse) {\n  transition: height 250ms;\n}\n\n.statFooter {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--stat--border);\n  padding: 0.25em 0.625em .375em;\n  overflow: hidden;\n}\n\n.chartTitle {\n  composes: largeSize from '../../../styles/typography.css';\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  margin-top: .25em;\n  color: var(--stat--default);\n  width: 100%;\n  min-width: 0;\n  display: flex;\n}\n\n.chartTitleText {\n  display: inline-block;\n  min-width: 0;\n  overflow-x: clip;\n  text-overflow: ellipsis;\n}\n\n.chartSummary {\n  line-height: 1;\n  display: flex;\n  justify-content: space-between;\n}\n\n.summaryData {\n  display: inline-block;\n  white-space: nowrap;\n  padding-right: .35em;\n  padding-left: .35em;\n}\n\n.summaryData:last-child {\n  padding-right: 0;\n}\n\n.summaryValue {\n  composes: extraLargeSize from '../../../styles/typography.css';\n  opacity: 1;\n  display: inline-block;\n  font-weight: 500;\n}\n\n.summarySuffix {\n  composes: smallSize from '../../../styles/typography.css';\n  color: var(--stat--default);\n  font-weight: normal;\n  position: relative;\n  bottom: 1px;\n  padding-left: 1px;\n}\n\n.units {\n  composes: smallSize from '../../../styles/typography.css';\n  color: var(--stat--default);\n  font-weight: normal;\n  align-self: center;\n  line-height: 24px;\n  padding-left: .5em;\n}\n\n.chartTitleData {\n  composes: smallSize from '../../../styles/typography.css';\n  display: none;\n  padding-left: .25em;\n  align-items: center;\n  position: relative;\n  top: -1px;\n  color: var(--stat--default);\n}\n\n.chartTitleData span {\n  margin-top: 1px;\n}\n\n.chartTitleSuffix {\n  font-weight: normal;\n  padding-left: 1px;\n}\n\n.Stat.isOpen .chartTitleData {\n  display: inline-flex;\n}\n\n.chartCollapse {\n  margin-bottom: 0;\n  margin-right: -0.3em;\n  height: 24px;\n  line-height: 1;\n}\n\n.chartCollapse img {\n  position: relative;\n  cursor: pointer;\n}\n\n.chartWrapper {\n  padding-bottom: .125em;\n}\n\n.inputWrapper {\n  padding: 0.5em 0.625em .5em;\n}\n\n.inputWrapper label {\n  font-weight: 500;\n}\n\n.inputWrapper input[type=\"number\"] {\n  width: 45px;\n}\n\n.outputWrapper {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  color: var(--stat--default);\n}\n\n.outputValue {\n  font-weight: 500;\n  color: var(--stat--default);\n  margin-right: .25em;\n  position: relative;\n  top: 1px;\n}\n\n.outputSuffix {\n  composes: smallSize from '../../../styles/typography.css';\n  color: var(--stat--default);\n}\n\n.outputValueDisabled {\n  color: var(--stat--default);\n}\n\n.outputLabel {\n  font-weight: 500;\n  color: var(--stat--default);\n}\n\n.tooltipIcon {\n  position: relative;\n  top: -0.3em;\n  margin-left: 0.1em;\n}\n\n.tooltipIcon > img {\n  width: 0.9em;\n}\n\n.StatTooltipWrapper {\n  z-index: 1;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"StatWrapper": `Stat--StatWrapper--KWm_y`,
	"Stat": `Stat--Stat--cQ2U_`,
	"statHeader": `Stat--statHeader--TPpS6`,
	"statMain": `Stat--statMain--bVDPU`,
	"statFooter": `Stat--statFooter--mEztE`,
	"chartTitle": `Stat--chartTitle--lZSYG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["largeSize"]}`,
	"chartTitleText": `Stat--chartTitleText--uzqDQ`,
	"chartSummary": `Stat--chartSummary--QudLx`,
	"summaryData": `Stat--summaryData--wSEtu`,
	"summaryValue": `Stat--summaryValue--njf4T ${___CSS_LOADER_ICSS_IMPORT_0___.locals["extraLargeSize"]}`,
	"summarySuffix": `Stat--summarySuffix--KBz9E ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"units": `Stat--units--XCEsR ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"chartTitleData": `Stat--chartTitleData--TmZ6Q ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"chartTitleSuffix": `Stat--chartTitleSuffix--CgcRd`,
	"isOpen": `Stat--isOpen--IIudz`,
	"chartCollapse": `Stat--chartCollapse--jo1M7`,
	"chartWrapper": `Stat--chartWrapper--jkeYr`,
	"inputWrapper": `Stat--inputWrapper--wlg0q`,
	"outputWrapper": `Stat--outputWrapper--qgnDe`,
	"outputValue": `Stat--outputValue--on2Ws`,
	"outputSuffix": `Stat--outputSuffix--WEbZg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"outputValueDisabled": `Stat--outputValueDisabled--ydkWF`,
	"outputLabel": `Stat--outputLabel--CtKR1`,
	"tooltipIcon": `Stat--tooltipIcon--jgX3r`,
	"StatTooltipWrapper": `Stat--StatTooltipWrapper--i8dsZ`
};
export default ___CSS_LOADER_EXPORT___;
